export default "__VITE_ASSET__s8$04oFC__"